import { colors } from "styles/colors";

type Props = {
  className?: string;
};

export const HomeAppliancesIcon: React.FC<Props> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
    width="34"
    height="26"
    viewBox="0 0 34 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.7713 4.99988H30.598C31.9235 4.99988 32.998 5.89532 32.998 6.99988V22.9999C32.998 24.1045 31.9235 24.9999 30.598 24.9999H3.39805C2.07256 24.9999 0.998047 24.1045 0.998047 22.9999V6.99988C0.998047 5.89532 2.07256 4.99988 3.39805 4.99988H11.2285L12.1428 1H21.857L22.7713 4.99988Z"
      fill="white"
    />
    <path
      d="M22.7713 4.99988L21.7964 5.22271C21.9004 5.67742 22.3049 5.99988 22.7713 5.99988V4.99988ZM11.2285 4.99988V5.99988C11.6949 5.99988 12.0994 5.67742 12.2034 5.22271L11.2285 4.99988ZM12.1428 1V0C11.6763 0 11.2718 0.322465 11.1679 0.777175L12.1428 1ZM21.857 1L22.8319 0.777175C22.728 0.322465 22.3235 0 21.857 0V1ZM30.598 3.99988H22.7713V5.99988H30.598V3.99988ZM33.998 6.99988C33.998 5.18006 32.2974 3.99988 30.598 3.99988V5.99988C31.5497 5.99988 31.998 6.61057 31.998 6.99988H33.998ZM33.998 22.9999V6.99988H31.998V22.9999H33.998ZM30.598 25.9999C32.2974 25.9999 33.998 24.8197 33.998 22.9999H31.998C31.998 23.3892 31.5497 23.9999 30.598 23.9999V25.9999ZM3.39805 25.9999H30.598V23.9999H3.39805V25.9999ZM-0.00195312 22.9999C-0.00195312 24.8197 1.69874 25.9999 3.39805 25.9999V23.9999C2.44639 23.9999 1.99805 23.3892 1.99805 22.9999H-0.00195312ZM-0.00195312 6.99988V22.9999H1.99805V6.99988H-0.00195312ZM3.39805 3.99988C1.69874 3.99988 -0.00195312 5.18006 -0.00195312 6.99988H1.99805C1.99805 6.61057 2.44639 5.99988 3.39805 5.99988V3.99988ZM11.2285 3.99988H3.39805V5.99988H11.2285V3.99988ZM12.2034 5.22271L13.1176 1.22282L11.1679 0.777175L10.2536 4.77706L12.2034 5.22271ZM12.1428 2H21.857V0H12.1428V2ZM20.8822 1.22282L21.7964 5.22271L23.7462 4.77706L22.8319 0.777175L20.8822 1.22282Z"
      fill={colors.gray900}
    />
    <rect
      x="1.5"
      y="9.5"
      width="31"
      height="1"
      rx="0.5"
      fill="white"
      stroke={colors.gray900}
    />
    <path
      d="M17.5 21C21.0899 21 24 18.0899 24 14.5C24 10.9101 21.0899 8 17.5 8C13.9101 8 11 10.9101 11 14.5C11 18.0899 13.9101 21 17.5 21Z"
      fill="white"
      stroke={colors.pink500}
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);
};
